export default "__VITE_ASSET__tOAszDQW__"